/**
 * Validate platform is iFrame or a pop-up window
 * @returns {Boolean}
 */
const isEmbedded = () => {
  return window.top !== window
}

const sendViaPostMessage = (event, data, domain = '*') => {
  const params = { type: 'tamara_checkout_message', event, data }

  window.parent.postMessage(params, domain)
}

export { sendViaPostMessage, isEmbedded }
